import { render, staticRenderFns } from "./OrderGoodsItem.vue?vue&type=template&id=2593ffd5&"
import script from "./OrderGoodsItem.vue?vue&type=script&lang=js&"
export * from "./OrderGoodsItem.vue?vue&type=script&lang=js&"
import style0 from "./OrderGoodsItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports